import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=72f861ab&scoped=true&"
import script from "./AuthorDetail.vue?vue&type=script&lang=ts&"
export * from "./AuthorDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&id=72f861ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f861ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VProgressCircular})
